module.exports = __webpack_public_path__ + "img/shield_icon.47ed5113.svg";